import React from 'react';
import { ObjectWrapper } from './styles/Common.styles';
import { StyledInput } from './styles/Input.styles'; 
import { DateInputRow, DateInputIcon } from './styles/DateInput.styles';

const DateInputControl = ({ control, renderMode }) => (
  <ObjectWrapper>
    <DateInputRow>
      <StyledInput
        type="text"
        styleProps={control.attributes}
        defaultValue={control.defaultValue}
        renderMode={renderMode}
        height={control.height}
        readOnly
      />
      <DateInputIcon />
    </DateInputRow>
  </ObjectWrapper>
);

export default DateInputControl;